// extracted by mini-css-extract-plugin
export default {"bookingDetails":"Style_bookingDetails__BqBnQ","title":"Style_title__a1Wz6","colRight":"Style_colRight__hN7qu","row":"Style_row__ygPeX","colLeft":"Style_colLeft__cJcCX"};